import { Badge } from "@chakra-ui/react";
import { useEffect, useState } from "react";

export const CryptoCountdown = ({ startTime }) => {
  const [timeLeft, setTimeLeft] = useState("00:00");

  useEffect(() => {
    const target = new Date(startTime).getTime() + 15 * 60 * 1000;
    let timerInterval;

    const updateTimer = () => {
      const now = new Date().getTime();
      const remaining = target - now;

      if (remaining <= 0) {
        setTimeLeft("00:00");
        clearInterval(timerInterval);
        return;
      }

      const minutes = Math.floor(remaining / 60000)
        .toString()
        .padStart(2, "0");
      const seconds = Math.floor((remaining % 60000) / 1000)
        .toString()
        .padStart(2, "0");

      setTimeLeft(`${minutes}:${seconds}`);
    };

    updateTimer();
    timerInterval = setInterval(updateTimer, 1000);

    return () => clearInterval(timerInterval);
  }, [startTime]);

  const [min] = timeLeft.split(":").map(Number);

  let colorScheme = "green";
  if (min <= 10 && min > 5) colorScheme = "yellow";
  else if (min <= 5) colorScheme = "red";

  return (
    <Badge variant="surface" colorPalette={colorScheme}>
      {timeLeft}
    </Badge>
  );
};
